import React, { memo, useState, useMemo } from 'react';
import {useSelector} from 'react-redux';
import { isNormalZhEnCss } from '../../utils';
import styles from './styles.module.scss';

const Index = memo((props) => {


  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { lang } = useSelector(({localesReducer}) => localesReducer.i18n);


  const { data:{list, img, imgM} } = props.config;

  const [bgImg, setBgImg] = useState(img);

  // 样式判断
  const normal = useMemo(() => {
    if(recReSizeReducer > 1920){
      setBgImg(img);
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      setBgImg(img);
      return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      setBgImg(img);
      return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      setBgImg(img);
      return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      setBgImg(imgM);
      return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  }, [img, imgM, lang, recReSizeReducer]);

  // 判断是：桌面/移动端
  const desktopMobile = () => {

    return (
        <div
            className={normal}
            style={{background: `url(${bgImg}) no-repeat 100% 100%/cover`}}
        >
          {
            list.map(item => {
              return (
                  <div key={item.key} className="item">
                    <div className="info">
                      <h5 className="title">{item.title}</h5>
                      <p className="desc">{item.desc}</p>
                    </div>
                  </div>
              )
            })
          }
        </div>
    );
  };


  return desktopMobile();
});
export default Index;
